import { getDatasWithOption, handleApiError } from '../../utils/service';
import { truthy, parseInt10, numberWithCommas } from '../../utils/util';
import { getLoadingBarTpl } from '../../model/tpl/loadingbar';
import { BOARD } from '../../model/msg/board';

class Rank {
  constructor(options) {
    const _ = this;

    if (!options) return;

    _.option = $.extend({
      wrap: null,
      apiDomain: '',
      global: window
    }, options);

    _.wrap = _.option.wrap;

    _.DISPLAY_LEVEL_LIMIT = 60;
  }

  init() {
    const _ = this;

    _.setRankingBtn();
    _.setData();

    return _;
  }

  setData() {
    const _ = this,
      rankingBundle = $('.myranking__bundle', _.wrap);

    rankingBundle.hide();

    _.setLoadingBar(true);

    getDatasWithOption([{
      type: 'GET',
      url: `${_.option.apiDomain}/api/main/character/rank`,
      dataType: 'json',
      xhrFields: {withCredentials: true}

    }], (data) => {
      _.setLoadingBar(false);
      _.setInstance(data);

    }, (data) => {
      handleApiError(data);

      _.setLoadingBar(false);
      _.setInstance(null);
    });
  }

  setInstance(data) {
    const _ = this,
      rankingWrap = $('.wrap-myranking', _.wrap),
      rankingBundle = $('.myranking__bundle', rankingWrap);

    if (!data || !data.rank) {
      rankingWrap.append(`<div class="nodata">${BOARD.RETRY_LATER}</div>`);
      return;
    }

    const character = data.rank.gameCharacter;
    if (character && character.level < _.DISPLAY_LEVEL_LIMIT) {
      rankingWrap.append(`<div class="nodata">${'60레벨이 되면 내 랭킹 확인이 가능합니다.'}</div>`);
      return;
    }

    _.setRankWrap(data.rank);

    rankingBundle.show();
  }

  setRankWrap(rankData) {
    const _ = this,
      serverRank = numberWithCommas(parseInt10(rankData.serverRank || 0)),
      classRank = numberWithCommas(parseInt10(rankData.classRank || 0)),
      grade = parseInt10(rankData.grade || 0);

    $('.myranking__server dd', _.wrap).text(serverRank);
    $('.myranking__class dd', _.wrap).text(classRank);
    $('.myranking__grade dd > span', _.wrap).attr('class', `grade-${grade}`);
  }

  setRankingBtn() {
    const _ = this,
      rankingWrap = $('.wrap-myranking', _.wrap),
      btn = $('.btn-myranking', _.wrap);

    btn.on('click', function (evt) {
      if (btn.hasClass('on')) {
        btn.removeClass('on');
        rankingWrap.hide();

      } else {
        btn.addClass('on');
        rankingWrap.show();
      }
    });
  }

  setLoadingBar(flag) {
    const _ = this,
      wrap = $('.wrap-myranking', _.wrap);

    $('.loadingbar', wrap).remove();

    if (truthy(flag)) wrap.append(getLoadingBarTpl());
  }
}

export default Rank;


// WEBPACK FOOTER //
// ./_src/js/main/my/Rank.js